var _style, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F05125;}\r\n\t.st1{fill:#7FBB42;}\r\n\t.st2{fill:#FDB813;}\r\n\t.st3{fill:#32A0DA;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 30,
    height: 30
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    className: "st1",
    width: 30,
    height: 30
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    className: "st2",
    width: 30,
    height: 30
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 34,
    className: "st3",
    width: 30,
    height: 30
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsal);
export default __webpack_public_path__ + "static/media/msal.9cd425d2ed1e846036814382093d1cb8.svg";
export { ForwardRef as ReactComponent };